export const googleIntegrationFailureReasons = [
    'GOOGLE_ACCOUNT_NOT_AUTHORIZED',
    'GOOGLE_PERMISSIONS_REQUIRED',
    'GOOGLE_ACCOUNT_LINKED_ELSEWHERE',
    'GOOGLE_INTEGRATION_ALREADY_ACTIVE',
    'GOOGLE_RECONNECT_REQUIRED',
    'GOOGLE_DIRECTORY_EMPTY',
    'GOOGLE_IMPORT_NOT_FOUND',
    'GOOGLE_INVALID_REQUEST',
    'GOOGLE_TEMPORARILY_UNAVAILABLE',
    'GOOGLE_OPERATION_FAILED',
] as const;

export type GoogleIntegrationFailureReason = typeof googleIntegrationFailureReasons[number];

interface GoogleIntegrationApiError {
    message?: unknown;
    details?: unknown;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const isGoogleIntegrationFailureReason = (value: unknown): value is GoogleIntegrationFailureReason =>
    typeof value === 'string' && googleIntegrationFailureReasons.some((reason) => reason === value);

export const getGoogleIntegrationErrorMessage = (error: unknown, fallback: string): string => {
    if (!isRecord(error) || !isRecord(error.data)) return fallback;

    const apiError = error.data as GoogleIntegrationApiError;
    if (!isRecord(apiError.details) || !isGoogleIntegrationFailureReason(apiError.details.reason)) {
        return fallback;
    }

    return typeof apiError.message === 'string' && apiError.message.trim()
        ? apiError.message
        : fallback;
};
